import { render } from "./DynamicComponentElement.vue.js?vue&type=template&id=116995c1&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentElement.vue?vue&type=template&id=116995c1&scoped=true"
import script from "./DynamicComponentElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentElement.vue?vue&type=script&lang=js"
export * from "./DynamicComponentElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentElement.vue?vue&type=script&lang=js"

import "./DynamicComponentElement.vue.scss?vue&type=style&index=0&id=116995c1&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentElement.vue?vue&type=style&index=0&id=116995c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116995c1"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-component-element/DynamicComponentElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "116995c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('116995c1', __exports__)) {
    api.reload('116995c1', __exports__)
  }
  
  module.hot.accept("./DynamicComponentElement.vue.js?vue&type=template&id=116995c1&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentElement.vue?vue&type=template&id=116995c1&scoped=true", () => {
    api.rerender('116995c1', render)
  })

}


export default __exports__